module.exports = __webpack_public_path__ + "img/2-1.940b3330.png";